import React from 'react';
const DEFAULT_ICON_SIZE = 24;
export const withBaseIcon = (icon, { size = DEFAULT_ICON_SIZE, width = size, height = size, ...rest }) => {
    return React.cloneElement(icon, { width, height, ...rest });
};
